import { createApi } from '@reduxjs/toolkit/query/react';
import {
  createPartyMaster,
  CustomGetPartyMasterQuery,
  getCustomPartyMaster,
  getEmailsByPartyIds,
  GetEmailsByPartyIdsQuery,
  GetEmailsByPartyIdsQueryVariables,
  GetPartyMasterQueryVariables,
} from '../../../graphql';
import { baseQuery } from '../../../utils';
import { GetEmailsByPartyIdsQueryResponse, GetPartyMasterQueryResponse } from '../../../types/graphql';

export const sendEmailApi = createApi({
  reducerPath: 'sendEmailApi',
  baseQuery,
  tagTypes: ['sendEmail', 'emailbyPartyid'],
  endpoints: (builder) => ({
    getPartyMasterCustom: builder.query<GetPartyMasterQueryResponse, GetPartyMasterQueryVariables>({
      query: (variables) => ({
        body: getCustomPartyMaster,
        variables,
      }),
      providesTags: (result, error, { partyid }) => [{ type: 'sendEmail', id: partyid }],
      transformResponse: (response: CustomGetPartyMasterQuery) => response?.getPartyMaster || [],
      keepUnusedDataFor: 180,
    }),
    getEmailsByPartyIds: builder.query<GetEmailsByPartyIdsQueryResponse, GetEmailsByPartyIdsQueryVariables>({
      query: (variables) => ({
        body: getEmailsByPartyIds,
        variables,
      }),
      providesTags: (result, error, { partyIds }) => [{ type: 'emailbyPartyid', id: JSON.stringify(partyIds) }],
      transformResponse: (response: GetEmailsByPartyIdsQuery) => response?.getEmailsByPartyIds ?? [],
      keepUnusedDataFor: 180,
    }),
    updatePartyMaster: builder.mutation<void, any>({
      query: (variables) => ({
        body: createPartyMaster,
        variables,
      }),
      invalidatesTags: ['sendEmail','emailbyPartyid'],
    }),
  }),
});

export const { useGetPartyMasterCustomQuery, useGetEmailsByPartyIdsQuery, useUpdatePartyMasterMutation } = sendEmailApi;
